/** @jsxImportSource @emotion/react */

import { useFormContext } from "react-hook-form";
import { StyledText } from "../../../assets/typography/typography";
import { BaseUploadPreview } from "../../../components/BaseUploadPreview";

export const ImagePreview = () => {
  const {
    watch,
    formState: { errors: formErrors },
  } = useFormContext();
  const imageUrl = watch("imageUrl");

  return (
    <BaseUploadPreview url={imageUrl}>
      {formErrors.imageUrl?.message && (
        <StyledText className="bodySubtextRegular mb-0">
          {`${formErrors.imageUrl?.message}`}
        </StyledText>
      )}
    </BaseUploadPreview>
  );
};
